import { render } from "./ForgotResetPasswordView.vue?vue&type=template&id=2825a28f&scoped=true&ts=true"
import script from "./ForgotResetPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotResetPasswordView.vue?vue&type=script&lang=ts"

import "./ForgotResetPasswordView.vue?vue&type=style&index=0&id=2825a28f&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2825a28f"]])

export default __exports__